module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Hime\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("James Hime's electrifying debut, "), _c('I', [_vm._v("The Night of the Dance")]), _vm._v(", was a finalist for the Edgar Award for best first novel. Born in Arkansas, he lives in Dallas, Texas, with his wife and their golden retriever. "), _c('I', [_vm._v("Where Armadillos Go to Die")]), _vm._v(" is his third novel.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dcqkoE/tc-custom/9781429984287.jpg?1731797235246",
      "alt": "This image is the cover for the book Where Armadillos Go to Die, Jeremiah Spur Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Where Armadillos Go to Die, Jeremiah Spur Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sylvester Bradshaw owns the Bouree restaurant, home of the best catfish within a hundred miles of Brenham, Texas. Besides being known for his cooking and for being one of the town's nastiest residents, he also happens to have invented a machine that several venture capitalists and one former NFL star would like to invest in at almost any cost. But Bradshaw---stubborn and miserly---can't be enticed no matter what offer they put on the table. Nobody gets a look and nobody gets to know how the device works, not even his family."), _c('br'), _c('br'), _vm._v("When the restaurant is ransacked and he goes missing, the only person willing to take his disappearance seriously is Jeremiah Spur. The retired Texas Ranger and rancher is a dedicated customer, if not a friend, which makes him the only man on whom the Bradshaws can pin their hopes."), _c('br'), _c('br'), _vm._v("James Hime's "), _c('i', [_vm._v("Where Armadillos Go to Die")]), _vm._v(" eloquently captures the voice and spirit of a small Texas town with troubles every bit as big as the whole state, making for some of the most engaging crime fiction on bookshelves today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0